import LedgerScannerClient from '../clients/LedgerScannerClient'
import { solanaClient } from '../clients/SolanaClient'
import { logger } from '../logger'

import type { Wallet } from '../providers/WalletProvider'
import { type ICToken, type PlugToken } from '../interfaces/common'
import type { TokenBalance } from '../state/tokenBalances'
import { SOL_ID } from '../constants/tokenIds'

export const getTokenBalances = async (
  wallet: Wallet,
  tokens: PlugToken[]
): Promise<TokenBalance[]> => {
  const ledgerScannerBalances = getLedgerScannerBalances(wallet, tokens as ICToken[])
  return (await ledgerScannerBalances).filter((tb) => !!tb)
}

const getLedgerScannerBalances = async (wallet: Wallet, tokens?: ICToken[]) => {
  if (!tokens?.length) return []

  try {
    const balances = await LedgerScannerClient.fetchBalances(
      wallet,
      tokens.map((t) => t.id)
    )

    return tokens.map((token) => ({
      id: token.id,
      balance: (balances[token.id] || 0) * 10 ** -token.decimals,
    }))
  } catch (e) {
    logger.error(`Failed to get LS token balances`, { originalError: e })

    return []
  }
}

export const getTokenBalance = async (wallet: Wallet, token: PlugToken): Promise<number> => {
  if (token.id === SOL_ID) {
    if (!wallet.solAddress) return 0

    const balance = await solanaClient.getBalance(wallet.solAddress)

    return balance * 10 ** -token.decimals
  }

  const response = await LedgerScannerClient.fetchBalances(wallet, [token.id])

  const balance = response[token.id]
  return balance * 10 ** -token.decimals
}
